var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbStripes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-488.9%",
    y: "-400%",
    width: "1077.8%",
    height: "1077.8%",
    filterUnits: "objectBoundingBox",
    id: "ThumbStripes_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.229949 0 0 0 0 0.461254 0 0 0 0 0.626472 0 0 0 0.053333 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.231373 0 0 0 0 0.462745 0 0 0 0 0.627451 0 0 0 0.026667 0",
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "ThumbStripes_svg__[object_Object]b",
    cx: 13.5,
    cy: 13.5,
    r: 13.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-233 4H16v7h-249z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ThumbStripes_svg__[object_Object]a)",
    xlinkHref: "#ThumbStripes_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeLinejoin: "square",
    fill: "#FFF",
    cx: 13.5,
    cy: 13.5,
    r: 13
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5v-12m-4 12v-12m-4 12v-12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
export default SvgThumbStripes;